import {gql} from '@apollo/client';
import {PodReviewDetailType} from '../types/PodReviewType';
import {POD_REVIEW_DETAIL_FIELDS} from './getPodReviewOrders';

export const GET_POD_REVIEW_DETAIL_BY_ID = gql`
    query GetPodReviewDetailById($podManualReviewId: Long!) {
        getPodReviewDetailById(podManualReviewId: $podManualReviewId) {
            ${POD_REVIEW_DETAIL_FIELDS}
        }
    }
`;

export interface GetPodReviewDetailByIdResponse {
    getPodReviewDetailById: PodReviewDetailType | null;
}

